import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { PartnerType, Platform } from '../utils'
import { useEligibilitySubmissionStore } from './eligibilitySubmission'

export const useConfigStore = defineStore('config', () => {
    const eligibilitySubmissionStore = useEligibilitySubmissionStore()

    const shouldDisplayPersonalDetails = ref<boolean>(false)

    const shouldDisplayBusinessDetails = ref<boolean>(false)

    const shouldDisplayPostalCode = ref<boolean>(false)

    const isKbcOrEnergyAtHomePartner = computed<boolean>(function (): boolean {
        if (eligibilitySubmissionStore.eligibilitySubmission.platform === null) {
            return [PartnerType.Kbc, PartnerType.EnergyAtHome].includes(
                eligibilitySubmissionStore.eligibilitySubmission.partner?.type
            )
        }

        return eligibilitySubmissionStore.eligibilitySubmission.platform === Platform.Kbc
    })

    return {
        shouldDisplayPersonalDetails,
        shouldDisplayBusinessDetails,
        isKbcOrEnergyAtHomePartner,
        shouldDisplayPostalCode,
    }
})
